import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import Translation from "./translation.service";

var BillPaymentService = {};

BillPaymentService.requestOTP = data => {
// number: String
// process: String (optional)
// Note: for this case process = bill_payment
    let config = {
    method: "post",
    url: "/complaints/request_otp",
    data: data
    };
    return HTTP(config);
};


BillPaymentService.verifyOTP = data => {
    // number: String
    // otp: string
    let config = {
        method: "post",
        url: "/complaints/verify_otp",
        data: data
    };
    return HTTP(config);
};

BillPaymentService.billList = (number, no_of_bills) => {
    // number: String
    // no_of_bills: Int
    let config = {
        method: "get",
        url: `/postpaid_bills/list?number=${number}&no_of_bills=${no_of_bills}`,
        headers: {
            "Virgin-Lang": Translation.getCurrentLanguage()
        }
    };
    return HTTP(config);
};

BillPaymentService.billByInvoice = invoice_number => {
    // invoice_number: String
    // comma separated in case of multiple bills
    let config = {
        method: "get",
        url: `/postpaid_bills/pending_bills?invoice_number=${invoice_number}`,
        headers: {
            "Virgin-Lang": Translation.getCurrentLanguage()
        }
    };
    return HTTP(config);
};

BillPaymentService.billDownloadByInvoice = invoice_number => {
    // invoice_number: String
    // comma separated in case of multiple bills
    let config = {
        method: "get",
        url: `/postpaid_bills/download?invoice_number=${invoice_number}`,
        responseType: 'blob',
        headers: {
            "Virgin-Lang": Translation.getCurrentLanguage(),
            'Accept': 'application/pdf'
        }
    };
    return HTTP(config);
};
    
BillPaymentService.billPaymentVerifyTap = (data) => {
    Helpers.debug_payment("BillPaymentService.billPaymentVerifyTap", data);
    let config = {
        method: "post",
        url: "/postpaid_bills/bill_pay_confirmation_web",
        data: data,
    };
    return HTTP(config);
};

BillPaymentService.getCurrentPlan = number => {
    // number: String
    let config = {
        method: "get",
        url: `/plans?include_expired_promo=true&include_optional_promotions=true&number=${number}`,
        headers: {
            "Virgin-Lang": Translation.getCurrentLanguage()
        }
    };
    return HTTP(config);
};

BillPaymentService.getAllPlans = (product, number) => {
    // number: String
    let config = {
        method: "get",
        url: `/products/predefined_bundles?include_optional_promotions=true&product_codes=${product}&number=${number}`,
        headers: {
            "Virgin-Lang": Translation.getCurrentLanguage()
        }
    };
    return HTTP(config);
};

export default BillPaymentService;
